import React from 'react'

import { Image as ImageType } from '@application/Types/ComponentTypes'

import { Grid, Image } from './ImageGrid.styled'

export const ImageGrid = ({ images }: { images: ImageType[] }): JSX.Element => {
    return (
        <Grid>
            {images.map((image) => (
                <Image image={image} key={image.alternativeText} />
            ))}
        </Grid>
    )
}
